import {memo, useMemo} from 'react'

import BuildsFetcher from '../../../../../containers/BuildsFetcher'
import {restApi} from '../../../../../services/rest'
import type {ChangeId} from '../../../../../types'
import {stringifyId} from '../../../../../types'
import {emptyArray} from '../../../../../utils/empty'
import {getChange} from '../../Changes.selectors'
import ChangeBuilds from '../ChangeBuilds/ChangeBuilds'
import {getChangeDeploymentsArg} from '../ChangeDetailsTabs.rest'

import {useAppSelector} from 'src/hooks/react-redux'

type Props = {
  changeId: ChangeId
}

const DeploymentsTab = ({changeId}: Props) => {
  const personal = useAppSelector(state => getChange(state, changeId)?.personal)

  const buildTypesLocator = `id:${stringifyId(changeId)},personal:${personal || false}`
  const buildsLocator = `${buildTypesLocator},count:100000`

  const {buildTypes, ready} = restApi.endpoints.getChangeDeploymentConfigurations.useQuery(
    getChangeDeploymentsArg(buildTypesLocator),
    {
      selectFromResult: ({data}) => ({
        buildTypes: data?.buildType || emptyArray,
        ready: data != null,
      }),
    },
  )

  return useMemo(
    () => (
      <BuildsFetcher
        locator={buildsLocator}
        customEndpoint={`/changes/${buildTypesLocator}/deployments`}
        withQueued
      >
        <ChangeBuilds
          buildsLocator={buildsLocator}
          isDeployment
          buildTypes={buildTypes}
          ready={ready}
        />
      </BuildsFetcher>
    ),
    [buildTypesLocator, buildsLocator, buildTypes, ready],
  )
}

export default memo<Props>(DeploymentsTab)
